import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { Form, Formik, useFormik } from 'formik';
import {
  Button,
  Box,
  Grid,
  FormLabel,
} from '@mui/material';

import { COUNTRIES, USStates, CAProvinces } from 'utils/constant.js';
import InputField from 'components/Input-Field/input-field';
import SelectField from 'components/Select-Field/select-field';
import { Toggle } from 'rsuite';
import FormElements from 'components/FormElements';

const TruckForm = ({
  action,
  truck,
  isFormModal,
  saveFormHandler,
  updateFormHandler,
  exposeSubmit,
}) => {

  const TruckSchema = Yup.object().shape({
    truckType: Yup.string().required('Truck Type is required.'),
    truckNumber: Yup.string().required('Enter Truck/Trailer Number'),
    dotNumber: Yup.string().min(2).max(75).required('DOT Number is required.'),
    licensePlate: Yup.string().min(2).max(25).required('License Number is required.'),
    registeredCountry: Yup.string().min(2).max(25).required('Registered Country name is required.'),
    registeredState: Yup.string().min(2).max(25).required('Registered State name is required.'),
    registrationExpirationDate: Yup.date().min(new Date()).required('Registration Expiry date is required.'),
    insuranceNumber: Yup.string().min(2).max(25).required('Insurance number is required.'),
    insuranceExpirationDate: Yup.date().min(new Date()).required('Insurance Expiry date is required.')
  });

  return (
    <Formik
      initialValues={{ ...truck }}
      enableReinitialize={true}
      validationSchema={TruckSchema}
      onSubmit={action === 'Save' ? saveFormHandler : updateFormHandler}
    >
      {(formik) => {
        // expose the submitForm to parent via ref
        useEffect(() => {
          exposeSubmit?.(formik.submitForm);
        }, [formik.submitForm]);
        return (
          <Form>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <FormElements.SectionTitle title='General Information' />
              </Grid>              
              <Grid size={{ xs: 6, sm: 3 }}>
                <SelectField
                  label='Select Truck Type'
                  name='truckType'
                  select
                  value={formik.values.truckType}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.truckType && formik.errors.truckType)}
                  helperText={formik.touched.truckType && formik.errors.truckType}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  options={['TRACTOR', 'DRYVAN', 'FLATBED', 'REEFER', 'STEPDECK', 'TANKER', 'DUMP_TRUCK', 'BOX_TRUCK', 'LIVESTOCK']}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='DOT Number'
                  name='dotNumber'
                  value={formik.values.dotNumber}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.dotNumber && formik.errors.dotNumber)}
                  helperText={formik.touched.dotNumber && formik.errors.dotNumber}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 3 }}>
                <InputField
                  label='Truck or Trailer Number'
                  name='truckNumber'
                  value={formik.values.truckNumber}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.truckNumber && formik.errors.truckNumber)}
                  helperText={formik.touched.truckNumber && formik.errors.truckNumber}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 3 }}>
                <InputField
                  label='Miles Driven'
                  name='totalMilesDriven'
                  value={formik.values.totalMilesDriven}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.totalMilesDriven && formik.errors.totalMilesDriven)}
                  helperText={formik.touched.totalMilesDriven && formik.errors.totalMilesDriven}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>              
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='Make'
                  name='make'
                  value={formik.values.make}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.make && formik.errors.make)}
                  helperText={formik.touched.make && formik.errors.make}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='Model'
                  name='model'
                  value={formik.values.model}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.model && formik.errors.model)}
                  helperText={formik.touched.model && formik.errors.model}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 2 }}>
                <InputField
                  label='Year'
                  name='year'
                  type='number'
                  value={formik.values.year}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.year && formik.errors.year)}
                  helperText={formik.touched.year && formik.errors.year}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 2 }}>
                <InputField
                  label='Weight'
                  name='capacityWeight'
                  type='number'
                  value={formik.values.capacityWeight}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.capacityWeight && formik.errors.capacityWeight)}
                  helperText={formik.touched.capacityWeight && formik.errors.capacityWeight}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 4, sm: 2 }}>
                <InputField
                  label='Length'
                  name='length'
                  value={formik.values.length}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.vinNumber && formik.errors.length)}
                  helperText={formik.touched.length && formik.errors.length}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <FormElements.SectionTitle title='Registration Information' />
              </Grid> 
              <Grid size={{ xs: 8, sm: 3 }}>
                <InputField
                  label='License Number'
                  name='licensePlate'
                  value={formik.values.licensePlate}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.licensePlate && formik.errors.licensePlate)}
                  helperText={formik.touched.licensePlate && formik.errors.licensePlate}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 3}}>
                <SelectField
                  label='Registered Country'
                  name='registeredCountry'
                  value={formik.values.registeredCountry}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.registeredCountry && formik.errors.registeredCountry)}
                  helperText={formik.touched.registeredCountry && formik.errors.registeredCountry}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  options={COUNTRIES}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <SelectField
                  label='Registered State/Province'
                  name='registeredState'
                  select
                  value={formik.values.registeredState}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.registeredState && formik.errors.registeredState)}
                  helperText={formik.touched.registeredState && formik.errors.registeredState}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  options={formik.values['registeredCountry'] === 'USA' ? USStates : CAProvinces}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='Registration Expiry Date'
                  name='registrationExpirationDate'
                  value={formik.values.registrationExpirationDate}
                  type='date'
                  variant='outlined'
                  fullWidth
                  slotProps={{ inputLabel: { shrink: true } }}
                  error={Boolean(formik.touched.registrationExpirationDate && formik.errors.registrationExpirationDate)}
                  helperText={formik.touched.registrationExpirationDate && formik.errors.registrationExpirationDate}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <FormElements.SectionTitle title='Insurance Information' />
              </Grid>               
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='VIN Number'
                  name='vinNumber'
                  value={formik.values.vinNumber}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.vinNumber && formik.errors.vinNumber)}
                  helperText={formik.touched.vinNumber && formik.errors.vinNumber}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='Insurance Policy Number'
                  name='insuranceNumber'
                  value={formik.values.insuranceNumber}
                  variant='outlined'
                  fullWidth
                  error={Boolean(formik.touched.insuranceNumber && formik.errors.insuranceNumber)}
                  helperText={formik.touched.insuranceNumber && formik.errors.insuranceNumber}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='Policy Expiry Date'
                  name='insuranceExpirationDate'
                  value={formik.values.insuranceExpirationDate}
                  type='date'
                  variant='outlined'
                  slotProps={{ inputLabel: { shrink: true } }}
                  fullWidth
                  error={Boolean(formik.touched.insuranceExpirationDate && formik.errors.insuranceExpirationDate)}
                  helperText={formik.touched.insuranceExpirationDate && formik.errors.insuranceExpirationDate}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid size={{xs: 6, sm: 3}}></Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <Box display={'flex'} gap={1} alignItems={'center'}>
                  <FormLabel component='legend'>Available</FormLabel>
                  <Toggle
                    name='isAvailable'
                    value={formik.values.isAvailable}
                    checkedChildren='YES'
                    unCheckedChildren='NO'
                    defaultChecked={formik.values.isAvailable}
                    onChange={(val) => setFieldValue('isAvailable', val)}
                  />
                </Box>
              </Grid>
              <Grid size={{ xs: 6, sm: 3 }}>
                <InputField
                  label='Service Date'
                  name='lastServiceDate'
                  value={formik.values.lastServiceDate}
                  type='date'
                  variant='outlined'
                  slotProps={{ inputLabel: { shrink: true } }}
                  fullWidth
                  error={Boolean(formik.touched.serviceDate && formik.errors.serviceDate)}
                  helperText={formik.touched.serviceDate && formik.errors.serviceDate}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                />
              </Grid>
            </Grid>
            {isFormModal &&
              <Box
                display='flex'
                justifyContent='flex-end'
                p={2}>
                {action === 'Save' ?
                  <Button
                    type='submit'
                    variant='contained'
                    color='primary'
                  >
                    Save Truck
                  </Button> :
                  <Button
                    type='submit'
                    variant='contained'
                    color='primary'
                  >
                    Update Truck
                  </Button>
                }
              </Box>}
          </Form>
        )
      }}
    </Formik>
  );
};
export default TruckForm;